<template>
  
  <div id="quotation-payment" class="sixteen wide column">
    <div class="ui segment" :class="{ loading }">
      <h4 class="ui dividing header">Pagamento</h4>
      <form class="ui form">
        <div class="fields">
          <div class="eight wide field" :class="{ disabled: productInputVisible || !canChangeCondition }">
            <label class="form-label">Condição <span class="red text">*</span></label>
            <select id="select-payment-condition" class="ui fluid search dropdown" v-model="selectedCondition">
              <option value="">Selecione...</option>
              <option v-for="condition in conditions" :value="condition.id">
                {{ condition.description }}
              </option>
            </select>
          </div>          
        </div>
        <div v-if="!canChangeCondition" class="ui small label m-t-10">
          <i class="info circle icon"></i>
          Defina o tipo do orçamento e o cliente
        </div>
      </form>
    </div>
  </div>

</template>

<script>

  import QuotationService from "@/services/quotation-service"

  export default {
    
    data() {
      return {
        loading: false,
        canChangeCondition: false,
        selectedCondition: "",
        conditions: [],
      }
    },

    props: ["quotation", "isCreating", "isUpdating", "productInputVisible"],

    computed: {

      paymentDescription() {

        if (this.quotation && this.quotation.descPayment) {
          return this.quotation.descPayment
        } else {
          return "Defina o tipo do orçamento e o cliente"
        }
      },
    },

    watch: {

      "selectedCondition" () {
         if(this.selectedCondition){
           this.onChange()
         }
      },
    },

    mounted() {

      $("#select-payment-condition").dropdown()

      this.loadConditions()      
    },

    methods: {

      async loadConditions() {

        this.canChangeCondition = false  

        if (!this.productInputVisible && this.quotation.type && this.quotation.customer && this.quotation.customer.code)
          this.canChangeCondition = true

        if (!this.canChangeCondition) {       
          this.selectedCondition = ""          
          $("#select-payment-condition").dropdown("clear")
          return
        }

        this.loading = true

        try {

          const { type, codeCustomer, unitCustomer } = this.quotation

          this.conditions = await QuotationService.getPaymentConditions(type, codeCustomer, unitCustomer)

          let values = []
          let selectLabel = "Selecione..."

          values.push({
            value: "",
            name: selectLabel,
            text: selectLabel,
          })

          this.conditions.forEach((condition) => {
            values.push({
              value: condition.id,
              name: condition.description,
              text: condition.description,            
            })
          })

          const customerCondition = this.quotation.customer.paymentCondition
          const isBonus = (this.quotation.type == "3")

          if (!isBonus && customerCondition && !this.conditionExists(customerCondition)) {
            values.push({
              value: customerCondition,
              name: this.quotation.customer.descPayment,
              text: this.quotation.customer.descPayment,
            })
          }

          $("#select-payment-condition").dropdown("clear")
          $("#select-payment-condition").dropdown("change values", values)

          let setSelected = ""

          if (this.conditions.length == 1) {
            
            setSelected = this.conditions[0].id

          } else if (!isBonus && customerCondition && !this.quotation.paymentCondition) {
            
            setSelected = customerCondition

          } else if (this.quotation.paymentCondition) {
            
            setSelected = this.quotation.paymentCondition
          }  

          if (setSelected) {
            this.loading = false
            $("#select-payment-condition").dropdown("set selected", setSelected)
            this.selectedCondition = setSelected
          } else {
            setTimeout(() => this.loading = false, 1000)
          }          
          
        } catch (error) {

          this.loading = false
          
          this.$errorHandler(error)          
        }
      },

      conditionExists(id) {

        let exists = false

        this.conditions.forEach((condition) => {
          if (condition.id == id)
            exists = true
        })

        return exists
      },

      onChange() {

        if (this.loading || !typeof this.selectedCondition == "string")
          return

        let selectedCondition = { id: "", description: "" }

        this.conditions.forEach((condition) => {
          if (condition && this.selectedCondition && condition.id.trim() == this.selectedCondition.trim())
            selectedCondition = this.$cloneObject(condition)
        })

        this.$emit("onChange", selectedCondition)
      }
    },
  }

</script>

